import { render, staticRenderFns } from "./agentDetail.vue?vue&type=template&id=ef31cdf8&scoped=true"
import script from "./agentDetail.vue?vue&type=script&lang=js"
export * from "./agentDetail.vue?vue&type=script&lang=js"
import style0 from "./agentDetail.vue?vue&type=style&index=0&id=ef31cdf8&prod&lang=css"
import style1 from "./agentDetail.vue?vue&type=style&index=1&id=ef31cdf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef31cdf8",
  null
  
)

export default component.exports